import Vue from 'vue';
const state = {
    relation: {},
    relations: [],
}
const actions = {
    showRelations: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/relations`).then(response => {
                context.commit('SHOW_RELATIONS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showRelation: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/relations/${id}`).then(response => {
                context.commit('SHOW_RELATION', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeRelation: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/relations`, payload).then(response => {
                context.commit('STORE_RELATION', response.data)
                context.dispatch('showRelations')
                Vue.$toast.success("Relacionamento cadastrado");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateRelation: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/relations/${payload.id}`, payload).then(response => {
                context.dispatch('showRelations')
                Vue.$toast.info("Relacionamento atualizado");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyRelation: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/relations/${id}`).then(response => {
                context.dispatch('showRelations')
                Vue.$toast.error("Relacionamento deletado");
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_RELATION: (state, payload) => {
        state.relation = payload
    },
    SHOW_RELATIONS: (state, payload) => {
        state.relations = payload
    },
    STORE_RELATION: (state, payload) => {
        state.relation = payload
    }
}
const getters = {
    relation: state => {
        return state.relation
    },
    relations: state => {
        return state.relations
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
